export default __webpack_public_path__ + "0fe5f821517dfb41f010180c3012770a.png";